import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import { acceptTerms, logout } from '../../actions/auth'
import AcceptTermsModal from '../../components/login/accept-terms'

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch, newProps) => ({
  handleClose () {
    dispatch(logout())
  },
  acceptTermsAgreement () {
    dispatch(acceptTerms())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AcceptTermsModal)



// WEBPACK FOOTER //
// ./src/containers/login/accept-terms-container.js